export default __webpack_public_path__ + "media/zurb/img/legacy/icons/press/tnw-c79e5abb930482a6c417e1f0a9d662f6.png";